import React, { useState } from "react";

const AppointmentSettingsclinic = () => {
  const [activeTab, setActiveTab] = useState("workingHours");
  const [selectedSlots, setSelectedSlots] = useState([]);
  const [isChangePasswordVisible, setIsChangePasswordVisible] = useState(false);
  const [emailNotifications, setEmailNotifications] = useState(true);
  const [smsAlerts, setSmsAlerts] = useState(false);
  const [iscancellation, setiscancellation] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);

  const [weeklySchedule, setWeeklySchedule] = useState({
    Monday: [],
    Tuesday: [],
    Wednesday: [],
    Thursday: [],
    Friday: [],
    Saturday: [],
    Sunday: [],
  });
  // Function to toggle visibility
  const toggleChangePassword = () => {
    setActiveTab("workingHours");
    setIsChangePasswordVisible(!isChangePasswordVisible);
  };
  const toggleclose = () => {
    setActiveTab("workingHours");
    setiscancellation(!iscancellation);
  };
  const handleTimeBlockChange = (day, index, field, value) => {
    const newSchedule = [...weeklySchedule[day]];
    newSchedule[index][field] = value;
    setWeeklySchedule((prevState) => ({
      ...prevState,
      [day]: newSchedule,
    }));
  };
  // const timeSlots = [
  //   "10:00 -10:30AM",
  //   "10:30 -11:00AM",
  //   "11:00 -11:30AM",
  //   "11:30 -12:00PM",
  //   "12:00 -12:30PM",
  //   "12:30 -01:00PM",
  //   "01:00 -01:30PM",
  //   "01:30 -02:00PM",
  //   "02:00 -02:30PM",
  //   "02:30 -03:00PM",
  //   "03:00 -03:30PM",
  //   "03:30 -04:00PM",
  //   "04:00 -04:30PM",
  //   "04:30 -05:00PM",
  //   "05:00 -05:30PM",
  //   "05:30 -06:00PM",
  // ];

  const handleSlotClick = (slot) => {
    setSelectedSlots((prev) =>
      prev.includes(slot) ? prev.filter((s) => s !== slot) : [...prev, slot]
    );
  };
  const handleCancellationPolicy = () => {
    setActiveTab("Cancellation");
    setiscancellation(!iscancellation);
  };
  const handlenotification = () => {
    setActiveTab("notifications");
    setIsChangePasswordVisible(!isChangePasswordVisible);
  };
  const addTimeBlock = (day) => {
    const newBlock = { start: "08:00", end: "17:00", location: "Main Office" };
    setWeeklySchedule((prevState) => ({
      ...prevState,
      [day]: [...prevState[day], newBlock],
    }));
  };

  const removeTimeBlock = (day, index) => {
    setWeeklySchedule((prevState) => {
      const newDaySchedule = prevState[day].filter((_, i) => i !== index);
      return {
        ...prevState,
        [day]: newDaySchedule,
      };
    });
  };
  const handleSaveSettings = () => {
    // Save the settings here
    alert("Settings saved successfully!");
    setShowSettingsModal(false); // Close modal after saving
  };
  return (
     <div className="section-box">
      {/* <div className="tab-container" style={{ marginBottom: 80 }}>
        <div
          className={
            activeTab === "workingHours" ? "active-tab" : "inactive-tab"
          }
          onClick={() => setActiveTab("workingHours")}
        >
          Booking Slots
        </div>
        <div
          className={
            activeTab === "Cancellation" ? "active-tab" : "inactive-tab"
          }
          onClick={handleCancellationPolicy}
        >
          Cancellation Policy
        </div>
        <div
          className={
            activeTab === "notifications" ? "active-tab" : "inactive-tab"
          }
          onClick={handlenotification}
        >
          Reminder & Notification
        </div>
      </div> */}
    <div className="tab-bar">
  <button className={`tab-button_two ${activeTab === "workingHours" ? "active" : ""}`} onClick={() => setActiveTab("workingHours")}>
    <i className="fas fa-calendar-check" /> Booking Slots
  </button>
  <button className={`tab-button_two ${activeTab === "Cancellation" ? "active" : ""}`} onClick={handleCancellationPolicy}>
    <i className="fas fa-ban" /> Cancellation Policy
  </button>
  <button className={`tab-button_two ${activeTab === "notifications" ? "active" : ""}`} onClick={handlenotification}>
    <i className="fas fa-bell" /> Notifications
  </button>
</div>

      {activeTab === "workingHours" && (
        // <div className="grid-container">
        //   {timeSlots.map((slot) => (
        //     <div
        //       key={slot}
        //       className={
        //         selectedSlots.includes(slot)
        //           ? "time-slot selected"
        //           : "time-slot"
        //       }
        //       onClick={() => handleSlotClick(slot)}
        //     >
        //       {slot}
        //     </div>
        //   ))}
        // </div>
        <>
          <div style={{ width: "100%" }}>
            <div
              className="modal-content_CalendarView_two"
              style={{ width: "100%" }}
            >
              <h2 style={{ color: "white" }}>Working Hours Settings</h2>
              <p>
                Configure your working hours, locations, and scheduling
                constraints.
              </p>
              <div id="settings-days-container" style={{ marginBottom: 20 }}>
                {Object.keys(weeklySchedule).map((day) => (
                  <div key={day} className="day-row_CalendarView">
                    <div className="day-row-header_CalendarView">
                      <strong>{day}</strong>
                      <button
                        type="button"
                        className="add-block-btn_CalendarView"
                        //  className="add-button_user"
                        onClick={() => addTimeBlock(day)}
                      >
                        Add Time Block
                      </button>
                    </div>
                    <div className="time-blocks_CalendarView">
                      {weeklySchedule[day].map((block, index) => (
                        <div key={index} className="time-block_CalendarView">
                          <label>Start:</label>
                          <input
                            type="time"
                            value={block.start}
                            onChange={(e) =>
                              handleTimeBlockChange(
                                day,
                                index,
                                "start",
                                e.target.value
                              )
                            }
                          />
                          <label>End:</label>
                          <input
                            type="time"
                            value={block.end}
                            onChange={(e) =>
                              handleTimeBlockChange(
                                day,
                                index,
                                "end",
                                e.target.value
                              )
                            }
                          />
                          <label>Location:</label>
                          <select
                            value={block.location}
                            onChange={(e) =>
                              handleTimeBlockChange(
                                day,
                                index,
                                "location",
                                e.target.value
                              )
                            }
                          >
                            <option value="Main Office">Main Office</option>
                            <option value="Satellite Office">
                              Satellite Office
                            </option>
                            <option value="Telehealth">Telehealth</option>
                          </select>
                          <button
                            type="button"
                            className="remove-block-btn_CalendarView"
                            onClick={() => removeTimeBlock(day, index)}
                          >
                            Remove
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
              <div className="section_CalendarView" id="constraints-section">
                <div
                  className="section-header_CalendarView"
                  style={{ textAlign: "left" }}
                >
                  Scheduling Constraints
                </div>
                <div className="form-row_CalendarView">
                  <div className="form-group_CalendarView">
                    <label htmlFor="min-gap">
                      Minimum Gap Between Sessions (minutes):
                    </label>
                    <input
                      type="number"
                      id="min-gap"
                      name="min-gap"
                      min={0}
                      defaultValue={15}
                    />
                  </div>
                  <div className="form-group_CalendarView">
                    <label htmlFor="max-appointments">
                      Maximum Appointments Per Day:
                    </label>
                    <input
                      type="number"
                      id="max-appointments"
                      name="max-appointments"
                      min={1}
                      defaultValue={8}
                    />
                  </div>
                  <div className="form-group_CalendarView">
                    <label htmlFor="max-weekly-appointments">
                      Maximum Appointments Per Week:
                    </label>
                    <input
                      type="number"
                      id="max-weekly-appointments"
                      name="max-weekly-appointments"
                      min={1}
                      defaultValue={40}
                    />
                  </div>
                </div>
                <div className="form-row_CalendarView">
                  <div className="form-group_CalendarView">
                    <label htmlFor="booking-leadtime">
                      Client Booking Lead Time (Hours):
                    </label>
                    <input
                      type="number"
                      id="booking-leadtime"
                      name="booking-leadtime"
                      min={1}
                      defaultValue={24}
                    />
                  </div>
                  <div className="form-group_CalendarView">
                    <label htmlFor="cancellation-leadtime">
                      Cancellation Lead Time (Hours):
                    </label>
                    <input
                      type="number"
                      id="cancellation-leadtime"
                      name="cancellation-leadtime"
                      min={1}
                      defaultValue={24}
                    />
                  </div>
                </div>
                <div className="form-row_CalendarView">
                  <div className="form-group_CalendarView">
                    <label htmlFor="break-start">
                      Mandatory Break (Start):
                    </label>
                    <input
                      type="time"
                      id="break-start"
                      name="break-start"
                      defaultValue="12:00"
                    />
                  </div>
                  <div className="form-group_CalendarView">
                    <label htmlFor="break-end">Mandatory Break (End):</label>
                    <input
                      type="time"
                      id="break-end"
                      name="break-end"
                      defaultValue="13:00"
                    />
                  </div>
                </div>
                <div className="form-row_CalendarView">
                  <div className="form-group_CalendarView">
                    <label htmlFor="min-appt-duration">
                      Minimum Appointment Duration (Minutes):
                    </label>
                    <input
                      type="number"
                      id="min-appt-duration"
                      name="min-appt-duration"
                      min={1}
                      defaultValue={15}
                    />
                  </div>
                  <div className="form-group_CalendarView">
                    <label htmlFor="max-appt-duration">
                      Maximum Appointment Duration (Minutes):
                    </label>
                    <input
                      type="number"
                      id="max-appt-duration"
                      name="max-appt-duration"
                      min={1}
                      defaultValue={60}
                    />
                  </div>
                </div>
                <div className="form-row_CalendarView">
                  <div className="form-group_CalendarView">
                    <label htmlFor="buffer-before">
                      Buffer Time Before (Minutes):
                    </label>
                    <input
                      type="number"
                      id="buffer-before"
                      name="buffer-before"
                      min={0}
                      defaultValue={5}
                    />
                  </div>
                  <div className="form-group_CalendarView">
                    <label htmlFor="buffer-after">
                      Buffer Time After (Minutes):
                    </label>
                    <input
                      type="number"
                      id="buffer-after"
                      name="buffer-after"
                      min={0}
                      defaultValue={5}
                    />
                  </div>
                </div>
                <div className="form-row_CalendarView">
                  <div className="form-group_CalendarView">
                    <label htmlFor="calendar-increment">
                      Calendar Increment (minutes):
                    </label>
                    <select id="calendar-increment" name="calendar-increment">
                      <option value={5}>5</option>
                      <option value={10}>10</option>
                      <option value={15} selected="">
                        15
                      </option>
                      <option value={20}>20</option>
                      <option value={30}>30</option>
                      <option value={60}>60</option>
                    </select>
                  </div>
                </div>
                <p className="small_CalendarView">
                  <em>
                    For advanced constraints (equipment/room availability,
                    multi-provider overlaps, time zone rules, etc.), configure
                    in admin console or add here.
                  </em>
                </p>
              </div>

              {/* <div className="button-container_CalendarView">
                <button
                  type="button"
                  className="save-settings-button_CalendarView"
                  onClick={handleSaveSettings}
                >
                  Save Settings
                </button>
              </div> */}

            <div className="form-actions_VisitStatus">
              
              <button
             onClick={handleSaveSettings}
                className="btn_VisitStatus btn_VisitStatus-primary"
                style={{ marginLeft: 10 }}
              >
                Save Settings
              </button>
            </div>
            </div>
          </div>
        </>
      )}

      {activeTab === "notifications" && (
        <div>
          {isChangePasswordVisible && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
              }}
            >
              <div
                className="HelpSupport_div"
                style={{
                  maxWidth: "30%",
                }}
              >
                <div className="Contact_Us_txt" style={{ marginBottom: 20 }}>
                  Reminder & Notification
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: 30,
                  }}
                >
                  <div>
                    <h3 style={{ textAlign: "left", color: "white" }}>
                      Reminder
                    </h3>
                    {/* <div style={{ color: "white" }}>
                      Appointment reminders, new booking alerts
                    </div> */}
                  </div>
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={emailNotifications}
                      onChange={() =>
                        setEmailNotifications(!emailNotifications)
                      }
                    />
                    <span className="slider round"></span>
                  </label>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: 50,
                    marginBottom: 100,
                  }}
                >
                  <div>
                    <h3 style={{ textAlign: "left", color: "white" }}>
                      Notification
                    </h3>
                    {/* <div style={{ color: "white" }}>
                      Appointment reminders, new booking alerts
                    </div> */}
                  </div>
                  {/* <label className="switch">
                    <input
                      type="checkbox"
                      checked={smsAlerts}
                      onChange={() => setSmsAlerts(!smsAlerts)}
                    />
                  </label>{" "} */}
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={smsAlerts}
                      onChange={() => setSmsAlerts(!smsAlerts)}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: 30,
                  }}
                >
                  <div className="cancelButton" onClick={toggleChangePassword}>
                    Cancel
                  </div>
                  <div className="savebuttonn" onClick={toggleChangePassword}>
                    Save
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      {activeTab === "Cancellation" && (
        <div>
          {iscancellation && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
              }}
            >
              <div
                className="HelpSupport_div"
                style={{
                  maxWidth: "30%",
                }}
              >
                <div className="Contact_Us_txt" style={{ marginBottom: 20 }}>
                  Cancellation Policy
                </div>
                <div
                  style={{
                    marginTop: 20,
                    color: "#FFFFFF",
                    marginBottom: 10,
                  }}
                >
                  Our agency requires a minimum of 24 hours' notice for
                  appointment cancellations. Cancellations made less than 24
                  hours in advance will incur a 50% fee of the scheduled
                  service. No-shows will be charged the full service amount.
                  Rescheduling with proper notice is allowed once without
                  penalty. Thank you for your understanding and cooperation
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: 30,
                  }}
                >
                  <div className="cancelButton" onClick={toggleclose}>
                    Cancel
                  </div>
                  <div className="savebuttonn" onClick={toggleclose}>
                    Save
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      <div
        style={{
          alignSelf: "center",
          display: "flex",
          width: "100%",
          justifyContent: "center",
          // bottom: 50,
          // position: "absolute",
          marginTop: 30,
          marginBottom: 30,
        }}
      >
        {/* <div className="cancelButton">Cancel</div>
        <div style={{ width: "10%" }}></div>
        <div className="savebuttonn">Save</div> */}
      </div>
    </div>
  );
};

export default AppointmentSettingsclinic;
